import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {BenjiKIV} from "../../BenjiKIV";
import {BenjiKIVSymbol} from "../../reels/BenjiKIVSymbol";
import {BenjiKIVStatics} from "../../BenjiKIVStatics";
import {gsap} from "gsap";
import {BenjiKIVGameMode} from "../../server/BenjiKIVGameMode";

/**
 * Created by Jerker Nord on 2022-12-02.
 */

export class BenjiKIVSuperFreeSpinSpinRunner implements SimplePresentation {

    public shouldRun():boolean {
        return true;
    }

    public start(controller:SimplePresentationRunnerController):void {
        //Triggers overlay scatters for different modes. Needs to be done here so no new server reply has time to sneak in.
        BenjiKIV.respinOverlayRunner.run = false;
        BenjiKIV.freeSpinOverlayRunner.run = false;
        BenjiKIV.superFSOverlayRunner.run = false;
        BenjiKIV.normalBoostedOverlayRunner.run = false;

        if((BenjiKIV.model.data.mode == BenjiKIVGameMode.SUPER_FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
        ) {
            BenjiKIV.superFSOverlayRunner.run = true;
        }

        //Hide intro (if active)
        BenjiKIV.introView.hideIntro();

        //Remove dark overlay on all syms
        for(let i:number = 0; i < BenjiKIV.allReelView.reelModels.length; i++) {
            for(let j:number = 0; j < BenjiKIV.allReelView.reelModels[i].reelView.symbols.length; j++) {
                (<BenjiKIVSymbol>BenjiKIV.allReelView.reelModels[i].reelView.symbols[j]).darkOverlay.alpha = 0;
            }
        }

        const tl:gsap.core.Timeline = gsap.timeline({onComplete : () => controller.finish()});

        //Reset enhancer view
        if((BenjiKIV.xBetView.boosted02Enabled == false && (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL))
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.SUPER_FREESPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL)
        ) {
            BenjiKIV.enhancerView.reset();
            tl.add(BenjiKIV.overlayScatterView.getHideAllOverlays());
        } else if(BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN) {
            BenjiKIV.enhancerView.reset();
            tl.add(BenjiKIV.overlayScatterView.getSetAllOverlaysToInitMultiplier());
            //Small delay before next SFS spin
            tl.add(gsap.timeline({delay : 0.4}));
        } else if((BenjiKIV.xBetView.boosted02Enabled == true && (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL))) {
            BenjiKIV.enhancerView.reset();
            tl.add(BenjiKIV.overlayScatterView.getSetAllOverlaysToInitMultiplier());
            //Small delay before next boosted spin
            tl.add(gsap.timeline({delay : 0.4}));
        } else if(BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN) {
            BenjiKIV.enhancerView.reset();
            tl.add(BenjiKIV.overlayScatterView.getSetAllOverlaysToInitMultiplier());
            //Small delay before next SFS spin
            tl.add(gsap.timeline({delay : 0.4}));
        } else if(BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN) {
            BenjiKIV.enhancerView.reset();
            tl.add(() => BenjiKIV.overlayScatterView.restoreAllMakeRoomOverlays());
            //Small delay before next SFS spin
            tl.add(gsap.timeline({delay : 0.4}));
        }

        //In FS they wake up by being reset
        BenjiKIV.overlayScatterPool.wakeUpAllOverlaysToIdle();

        const delay = BenjiKIVStatics.betweenReelsStartDelay;
        tl.add(BenjiKIV.allReelView.reelModels[0].start().restart(), 0);
        tl.add(BenjiKIV.allReelView.reelModels[1].start().restart(), delay);
        tl.add(BenjiKIV.allReelView.reelModels[2].start().restart(), delay * 2);
        tl.add(BenjiKIV.allReelView.reelModels[3].start().restart(), delay * 3);
        tl.add(BenjiKIV.allReelView.reelModels[4].start().restart(), delay * 4);
    }
}